import { call, takeEvery, getContext, put } from "redux-saga/effects";

import { forceSignOutActionType, signOutActionType } from "./actionTypes";
import { CONTEXT } from "@const/redux";
import { localstorageKeys } from "@const/store";
import { stopSocket } from "../socket/actions";
import storageService from "../../services/StorageService";

const signOutAsync = ({ SessionsService, accessToken }) => {
  if (!SessionsService) {
    console.log("Required services does not exist");

    return null;
  }

  return SessionsService.destroySession({ accessToken });
};

function* signOut() {
  const { SessionsService, StorageService } = yield getContext(
    CONTEXT.SERVICES,
  );
  const { accessToken } = StorageService.get(localstorageKeys.session, {});
  StorageService.clear();
  storageService.remove(localstorageKeys.destination);

  try {
    yield call(signOutAsync, { SessionsService, accessToken });
    yield put(stopSocket());
  } catch (e) {
    console.log(e);
  }
}

function* forceSignOut() {
  const { StorageService } = yield getContext(CONTEXT.SERVICES);
  StorageService.clear();
  storageService.remove(localstorageKeys.destination);

  window.location = "/";
}

export function* watchSignOut() {
  yield takeEvery(signOutActionType, signOut);
}

export function* watchForceSignOut() {
  yield takeEvery(forceSignOutActionType, forceSignOut);
}
